import { Resource as e } from "@coveo/platform-client";
//#region src/resources/SearchDictionaryFieldsResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/search/v3/analysis/documents";
	}
	listDictionaryFields(e, n) {
		return this.api.get(this.buildPath(`${t.baseUrl}/${e}/dictionary-fields`, {
			organizationId: this.api.organizationId,
			...n !== void 0 && { viewAllContent: n }
		}));
	}
	listKeyValuePairs(e, n, r) {
		return this.api.get(this.buildPath(`${t.baseUrl}/${e}/dictionary-fields/${n}`, {
			organizationId: this.api.organizationId,
			...r
		}));
	}
};
//#endregion
export { t as SearchDictionaryFieldsResource };

//# sourceMappingURL=SearchDictionaryFieldsResource.js.map